import { render, staticRenderFns } from "./MarketerTable.vue?vue&type=template&id=67df6732&scoped=true&"
import script from "./MarketerTable.vue?vue&type=script&lang=js&"
export * from "./MarketerTable.vue?vue&type=script&lang=js&"
import style0 from "./MarketerTable.vue?vue&type=style&index=0&id=67df6732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67df6732",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
